import React, { useEffect, useState } from "react";
import style from "./commonTable.module.css";
import { IoIosArrowDown } from "react-icons/io";
import Button from "../button/Button";
import {
  adminEpisodeFilterSearch,
  adminFilterSearch,
  adminSeasonFilterSearch,
  creatorEpisodeFilterSearch,
  creatorFilterSearch,
  creatorSeasonFilterSearch,
} from "../../api/HttpApis";
import { showToast } from "../../utils/Toastify/Toastify";
import NoDataFound from "../noDataFound/NoDataFound";
import PillCategoriesModal from "../../pages/PillCategories/pillCategorieModal";
import { useLocation } from "react-router-dom";
import Loader from "../../utils/loader/Loader";
import { GoPlus } from "react-icons/go";
import Pagination from "../../pages/pagination/Pagination";

const CommonTable = ({
  heading = true,
  columns,
  data,
  button = false,
  Library,
  totalCount = 0,
  onPageChange,
  para,
  Category = false,
  extraButton = null,
  containerClassName = "",
  handleFilterChange,
  selectedDate,
  selectedCreator,
  selectedRating,
  selectedGenre,
  tableLoading,
}) => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [adminDropDownData, setAdminDropDownData] = useState();
  const [dropDownData, setDropDownData] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const role = localStorage.getItem("role");
  const creatorNames = adminDropDownData?.creatorNames;
  const dataAdded = adminDropDownData?.dataAdded;
  const genreName = adminDropDownData?.genreNames;
  const ratingList = adminDropDownData?.ratingList;
  const totalPages = Math.ceil(
    (totalCount ||
      (Array.isArray(data) && data.length > 0 ? data[0].totalCount : 0) ||
      0) / rowsPerPage
  );
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const endpoint = pathSegments[pathSegments.length - 1];
  const endpoint2 = pathSegments[pathSegments.length - 2];

  const endpointData =
    endpoint === "movie"
      ? "movie"
      : endpoint === "creator-movie"
      ? "movie"
      : endpoint === "podcasts"
      ? "podcast"
      : endpoint === "short-clips"
      ? "short-clip"
      : endpoint === "live-tv-channels"
      ? "live-channel"
      : endpoint === "live-streams"
      ? "live-stream"
      : endpoint === "series"
      ? "series"
      : endpoint2 === "seasons"
      ? "season"
      : endpoint === "users"
      ? "users"
      : endpoint === "episodes"
      ? "episode"
      : "";
  // const seseason = endpoint2;
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(1);
    }
  }, [currentPage, totalPages, setCurrentPage]);
  useEffect(() => {
    if (onPageChange) {
      onPageChange(currentPage, rowsPerPage);
    }
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    const fetchDropDownData = async () => {
      try {
        setLoading(true);
        if (role === "Creator" && button) {
          if (endpointData === "episode") {
            const dropDownDataList = await creatorEpisodeFilterSearch(
              endpointData,
              endpoint2
            );
            setDropDownData(dropDownDataList?.data?.data);
          } else if (endpointData === "season") {
            
            const dropDownDataList = await creatorSeasonFilterSearch(
              endpointData,
              endpoint
            );
            setDropDownData(dropDownDataList?.data?.data);
          } else {
            const dropDownDataList = await creatorFilterSearch(endpointData);
            setDropDownData(dropDownDataList?.data?.data);
          }
          // showToast("success");
        }
      } catch (error) {
        showToast(error?.response?.data?.message || error?.message, "error");
      } finally {
        setLoading(false); // end loading
      }
    };
    fetchDropDownData();
  }, [role]);

  useEffect(() => {
    const fetchAdminDropDownData = async () => {
      try {
        setLoading(true);
        if (role === "Admin" && button) {
          if (endpointData === "episode") {
            const getDropdownData = await adminEpisodeFilterSearch(
              endpointData,
              endpoint2
            );
            setAdminDropDownData(getDropdownData?.data?.data);
            showToast(getDropdownData?.data.message, "success");
          } else if (endpointData === "season") {
            const getDropdownData = await adminSeasonFilterSearch(
              endpointData,
              endpoint
            );
            setAdminDropDownData(getDropdownData?.data?.data);
            showToast(getDropdownData?.data.message, "success");
          } else {
            const getDropdownData = await adminFilterSearch(endpointData);
            setAdminDropDownData(getDropdownData?.data?.data);
            showToast(getDropdownData?.data.message, "success");
          }
        }
      } catch (error) {
        showToast(error?.response?.data?.message || error?.message, "error");
      } finally {
        setLoading(false); // end loading
      }
    };
    fetchAdminDropDownData();
  }, [role]);

  return (
    <>
      <div>
        <div className={style.headerBtn}>
          {heading && Library ? (
            <div className={style.libraryBox}>
              {`${Library}/ ${heading}`}
              {para ? <div className={style.paraText}>{para}</div> : ""}
            </div>
          ) : heading && !Library ? (
            <div className={style.libraryBox}>
              {heading}
              {para ? <div className={style.paraText}>{para}</div> : ""}
            </div>
          ) : !heading && Library ? (
            <div className={style.libraryBox}>
              {Library}
              {para ? <div className={style.paraText}>{para}</div> : ""}
            </div>
          ) : null}

          {Category && (
            <div className={style.buttonBox}>
              <Button
                iconRight={<GoPlus className={style.arrowIcon} />}
                type="button"
                value={selectedCategory}
                onClick={() => setIsModalOpen(true)}
                variant="outline"
              >
                Category
              </Button>
              <PillCategoriesModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
              />
            </div>
          )}
          {button && (
            <div className={style.buttonBox}>
              {role === "Creator" ? (
                <>
                  {endpointData !== "season" ? (
                    <Button
                      iconRight={<IoIosArrowDown className={style.arrowIcon} />}
                      options={dropDownData?.genreNames}
                      type="select"
                      selectLabel="Genre"
                      variant="outline"
                      value={selectedGenre}
                      onChange={(e) =>
                        handleFilterChange("genre", e.target.value)
                      }
                    />
                  ) : null}
                  <Button
                    iconRight={<IoIosArrowDown />}
                    options={dropDownData?.dataAdded}
                    type="select"
                    selectLabel=" Date Submitted"
                    value={selectedDate}
                    variant="outline"
                    onChange={(e) => handleFilterChange("date", e.target.value)}
                  />
                </>
              ) : (
                <div className={style.buttonBox}>
                  {endpointData !== "season" ? (
                    <Button
                      iconRight={<IoIosArrowDown />}
                      type="select"
                      options={genreName}
                      selectLabel="Genre"
                      variant="outline"
                      value={selectedGenre}
                      onChange={(e) =>
                        handleFilterChange("genre", e.target.value)
                      }
                    >
                      Genre
                    </Button>
                  ) : null}

                  {/* <Button
                    iconRight={<IoIosArrowDown />}
                    options={creatorNames}
                    type="select"
                    selectLabel="All"
                    variant="outline"
                    value={selectedCreator}
                    onChange={(e) =>
                      handleFilterChange("creator", e.target.value)
                    }
                  /> */}
                  <Button
                    iconRight={<IoIosArrowDown />}
                    options={ratingList}
                    type="select"
                    selectLabel="Rating"
                    variant="outline"
                    value={selectedRating}
                    onChange={(e) =>
                      handleFilterChange("rating", e.target.value)
                    }
                  />
                  <Button
                    iconRight={<IoIosArrowDown />}
                    options={dataAdded}
                    type="select"
                    selectLabel="Date Added"
                    variant="outline"
                    value={selectedDate}
                    onChange={(e) => handleFilterChange("date", e.target.value)}
                  >
                    Date Added
                  </Button>
                </div>
              )}
            </div>
          )}
          {extraButton && (
            <div className={style.extraButtonWrapper}>{extraButton}</div>
          )}
        </div>
        <div className={`${style.tableContainer} ${containerClassName}`}>
          {/* {heading && <div className={style.heading}>{heading}</div>} */}

          <div className={style.tableWrapper}>
            <div className={style.scrollContainer}>
              <table
                width="100%"
                border="0"
                cellPadding="10"
                cellSpacing="0"
                // width="94%"
                // align="left"
                style={{ borderSpacing: "0 10px" }}
                // className={`${style.tableContainer} ${containerClassName}`}
              >
                <thead className={style.tableHeader}>
                  <tr>
                    {columns?.map((col) => (
                      <th key={col.key} style={{ textAlign: "left" }}>
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className={style.tableBody}>
                  {loading ? (
                    <tr>
                      <td colSpan={columns.length} className={style.loader}>
                        <Loader className={style.loader} />
                      </td>
                    </tr>
                  ) : !loading && data && data.length > 0 ? (
                    data?.map((item,index) => (
                      <tr key={`${item.id || "row"}-${index}`}>
                        {columns?.map((col) => (
                          <td
                            key={col.key}
                            style={{ textAlign: "left", padding: "10px 20px" }}
                          >
                            {col.render ? col.render(item) : item[col.key]}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : !tableLoading && !loading && data?.length === 0 ? (
                    <tr>
                      <td colSpan={columns.length}>
                        <NoDataFound />
                      </td>
                    </tr>
                  ) : null}
                </tbody>
                {/* <tfoot> */}
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalPages={totalPages}
                  totalCount={totalCount}
                  columnsLength={columns.length}
                  data={data}
                />
                {/* </tfoot> */}
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonTable;
